import React, { Component } from 'react'
import { Route, BrowserRouter, Redirect, Switch } from 'react-router-dom'
import Main from './components/Main'
import LoadingSplash from './components/LoadingSplash'
import Dashboard from './screens/Dashboard'
import Login from './screens/Login'
import RiskDetails from './screens/RiskDetails'
import RiskRegister from './screens/RiskRegister'
import { firebaseAuth, ref } from './config/constants'

export default class App extends Component {
  state = {
    authed: false,
    loading: true,
    risks: [],
    risksLoading: false,
    users: [],
    usersLoading: false
  }

  componentDidMount() {
    this.removeListener = firebaseAuth().onAuthStateChanged(user => {
      if (user) {
        this.setState({
          authed: true,
          loading: false,
          risksLoading: true,
          usersLoading: true
        })

        this.riskRef = ref.child(`users/${user.uid}/session/risks`)
        this.riskRef.on('value', snapshot => {
          this.setState({
            risksLoading: false,
            risks: snapshot
          })
        })

        this.userRef = ref.child(`users/${user.uid}/session/users`)
        this.userRef.on('value', snapshot => {
          this.setState({
            usersLoading: false,
            users: snapshot
          })
        })
      } else {
        this.setState({
          authed: false,
          loading: false
        })
      }
    })
  }

  componentWillUnmount() {
    this.removeListener()
    this.riskRef.off()
    this.userRef.off()
  }

  render() {
    return this.state.loading || this.state.risksLoading || this.state.usersLoading ? <LoadingSplash /> : (
      <BrowserRouter>
        <Switch>
          <Route exact path='/' render={() => this.state.authed ? <Redirect to='/risks' /> : <Redirect to='/login' />} />
          <Route path='/login' render={() => this.state.authed ? <Redirect to='/' /> : <Login />} />
          <Route path='/' render={props => (
            this.state.authed ? (
              <Main {...props}>
                <Switch>
                  <Route exact path='/dashboard' render={() => <Dashboard />} />
                  <Route exact path='/risks' render={registerProps => (
                    <RiskRegister
                      {...registerProps}
                      risks={this.state.risks}
                      users={this.state.users}
                    />
                  )} />
                  <Route path='/risks/:key' render={riskProps => (
                    <RiskDetails
                      {...riskProps}
                      risks={this.state.risks}
                      users={this.state.users}
                    />
                  )} />
                </Switch>
              </Main>
            ) : (
              <Redirect to='/login' />
            )
          )} />
        </Switch>
      </BrowserRouter>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js